import React, { useState } from 'react';
import { NewButton, TailwindModal } from '../../components/common';
import styles from './styles.module.scss';
import { isValidPhoneNumber } from '@alice/shared/utils/misc.util';

export default function SignupModal({ isVisible, onClose, signup }) {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    emailAddress: '',
    phone: '',
    acceptedTerms: true,
  });

  const updateForm = (key) => (value) => {
    setError('');
    setForm({
      ...form,
      [key]: value && value.target ? value.target.value : value,
    });
  };

  const submitForm = () => {
    setLoading(true);
    signup(form)
      .then(() => {
        onClose();
      })
      .catch((err) => {
        setError(err.message || 'Failed to create account. Please try again.');
        setLoading(false);
      });
  };

  const isValid =
    form.firstName &&
    form.lastName &&
    form.emailAddress &&
    isValidPhoneNumber(form.phone);

  return (
    <TailwindModal size="medium" isVisible={isVisible} onClose={onClose}>
      <div className="flex flex-col max-h-[600px]">
        <div
          className={`relative px-10 pt-8 pb-6 bg-linear-to-r from-orange-500 to-orange-400 overflow-hidden ${styles.signupHeaderAnimated}`}
        >
          <h2 className="relative z-10 m-0 text-3xl font-bold text-white text-center drop-shadow-md">
            Create Your Account
          </h2>
          <p className="relative z-10 mt-3 mb-0 text-sm text-white/95 text-center leading-relaxed drop-shadow-sm">
            Join us today! No password required - we'll use email verification
            to keep your account secure.
          </p>
        </div>

        <div className="flex-1 px-10 py-8 overflow-y-auto">
          <div className="relative mb-5">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-base z-20 pointer-events-none transition-all duration-300">
              <i className="fas fa-user"></i>
            </div>
            <input
              type="text"
              value={form.firstName}
              onChange={updateForm('firstName')}
              placeholder="First Name"
              className="relative z-10 w-full pl-12 pr-4 py-3.5 text-base text-slate-800 bg-slate-50 border-2 border-slate-200 rounded-xl outline-none transition-all duration-300 shadow-sm hover:border-slate-300 focus:bg-white focus:border-orange-400 focus:shadow-orange-100 focus:shadow-md"
            />
          </div>

          <div className="relative mb-5">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-base z-20 pointer-events-none transition-all duration-300">
              <i className="fas fa-user"></i>
            </div>
            <input
              type="text"
              value={form.lastName}
              onChange={updateForm('lastName')}
              placeholder="Last Name"
              className="relative z-10 w-full pl-12 pr-4 py-3.5 text-base text-slate-800 bg-slate-50 border-2 border-slate-200 rounded-xl outline-none transition-all duration-300 shadow-sm hover:border-slate-300 focus:bg-white focus:border-orange-400 focus:shadow-orange-100 focus:shadow-md"
            />
          </div>

          <div className="relative mb-5">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-base z-20 pointer-events-none transition-all duration-300">
              <i className="fas fa-envelope"></i>
            </div>
            <input
              type="email"
              value={form.emailAddress}
              onChange={updateForm('emailAddress')}
              placeholder="Email Address"
              className="relative z-10 w-full pl-12 pr-4 py-3.5 text-base text-slate-800 bg-slate-50 border-2 border-slate-200 rounded-xl outline-none transition-all duration-300 shadow-sm hover:border-slate-300 focus:bg-white focus:border-orange-400 focus:shadow-orange-100 focus:shadow-md"
            />
          </div>

          <div className="relative mb-5">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-base z-20 pointer-events-none transition-all duration-300">
              <i className="fas fa-phone"></i>
            </div>
            <input
              type="tel"
              value={form.phone}
              onChange={updateForm('phone')}
              placeholder="Mobile Phone Number"
              className="relative z-10 w-full pl-12 pr-4 py-3.5 text-base text-slate-800 bg-slate-50 border-2 border-slate-200 rounded-xl outline-none transition-all duration-300 shadow-sm hover:border-slate-300 focus:bg-white focus:border-orange-400 focus:shadow-orange-100 focus:shadow-md"
            />
          </div>

          {error && (
            <div
              className={`flex items-center gap-3 px-4 py-3 mt-4 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm leading-relaxed ${styles.slideDown}`}
            >
              <i className="fas fa-exclamation-circle shrink-0 text-base"></i>
              <span className="flex-1">{error}</span>
            </div>
          )}
        </div>

        <div className="flex gap-4 px-10 py-6 border-t border-slate-200 bg-slate-50">
          <NewButton
            size="lg"
            variant="bordered"
            color="gray"
            onClick={onClose}
            disabled={loading}
            className="flex-1"
          >
            Cancel
          </NewButton>
          <NewButton
            size="lg"
            variant="solid"
            color="primary"
            onClick={submitForm}
            disabled={!isValid}
            isLoading={loading}
            className="flex-1"
          >
            Create Account
          </NewButton>
        </div>
      </div>
    </TailwindModal>
  );
}
